
const navbarToggler = document.querySelector(".navbar-toggler");
const navbarCollapse = document.querySelector(".navbar-collapse");
const body = document.querySelector("body");

navbarToggler.addEventListener("click", () =>
	document.querySelector("body").classList.toggle("navbar--open"),
);

document.addEventListener("keydown", (event) => {
	if (event.key === "Escape" && navbarCollapse.classList.contains("show")) {
		navbarCollapse.classList.remove("show");
		navbarToggler.classList.add("collapsed");
		body.classList.remove("navbar--open");
	}
});

document.addEventListener('DOMContentLoaded', function() {
  const groupMenuCollapse = document.querySelector('.group-menu-collapse');
  const groupMenuToggler = document.querySelector('.group-menu-toggler');

  if (groupMenuCollapse && groupMenuToggler) {
    function handleMenuState() {
      const isLargeScreen = window.innerWidth >= 1201;

      if (isLargeScreen) {
        groupMenuCollapse.classList.add('show');
        groupMenuToggler.classList.remove('collapsed');
        groupMenuToggler.setAttribute('aria-expanded', 'true');
      } else {
        groupMenuCollapse.classList.remove('show');
        groupMenuToggler.classList.add('collapsed');
        groupMenuToggler.setAttribute('aria-expanded', 'false');
      }
    }
    handleMenuState();
    window.addEventListener('resize', handleMenuState);
  }
});